module.exports = __webpack_public_path__ + "static/img/wx1.587d149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/share/wx1.png
// module id = 4AL5
// module chunks = 1